<template>
  <stormy-dialog
    :show="show"
    :hide-header="true"
    :width="width"
    height="auto"
    @hide="emit('cancel')"
  >
    <template #content>
      <div class="flex items-center flex-1 px-4 py-4">
        <div class="mx-auto flex h-12 w-12 flex-none items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
          <ExclamationTriangleIcon
            class="h-6 w-6 text-red-600"
            aria-hidden="true"
          />
        </div>
        <div class="text-left mt-0 ml-4 flex-1 items-center flex flex-col ">
          <DialogTitle
            as="h3"
            class="text-lg font-medium  text-gray-900 flex-1 flex self-stretch"
          >
            <div class="flex items-center flex-1">
              <div class="flex-1">
                {{ title }}
              </div>
              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2"
                  @click="emit('cancel')"
                >
                  <span class="sr-only">Close</span>
                  <stormy-icon
                    name="x"
                    class="h-6 w-6"
                  />
                </button>
              </div>
            </div>
          </DialogTitle>

          <div class="tn-help-text self-stretch flex-1 flex text-left  mt-0.5">
            <p class=" text-gray-500 text-base">
              {{ message }}
            </p>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="space-x-2">
        <stormy-button
          tabindex="1"
          class="justify-center"
          variant="default"
          @click="emit('cancel')"
        >
          {{ textCancel }}
        </stormy-button>
        <stormy-button
          class="justify-center"
          variant="danger"
          @click="emit('confirm')"
        >
          {{ textConfirmation }}
        </stormy-button>
      </div>
    </template>
  </stormy-dialog>
</template>

<script setup>
import { computed } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { useProp } from '@/composables/useProp.js'
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
  show: useProp(Boolean),
  placement: useProp(String, 'center-center'),
  disabled: useProp(Boolean),
  backdrop: useProp(Boolean),
  backdropClases: useProp(String, 'bg-blue-500'),
  title: useProp(String, 'Löschen bestätigen'),
  message: useProp(String, 'Möchtest Du den Datensatz wirklich löschen?'),
  canClose: useProp(Boolean, true),
  width: useProp(String, 'sm'),
  textConfirmation: useProp(String, 'Löschen'),
  textCancel: useProp(String, 'Abbrechen'),
  variant: useProp(String, 'danger')
})

const cancelClasses = computed(() => {
  return {
    danger: 'bg-red-600 hover:bg-red-700  focus:ring-red-500',
    default: 'bg-blue-600 hover:bg-blue-700  focus:ring-blue-500'
  }[props.variant]
})

const emit = defineEmits(['cancel', 'confirm'])

</script>
